const API_BASE_URL = 'https://preoperacional.safite.com/api';
//const API_BASE_URL = 'http://localhost:8000/api';

export default API_BASE_URL;
